module.exports = "/_next/static/images/icon6-7160df84382d12606814b8f204ec0713.png";